import { Configuration, FrontendApi } from "@ory/kratos-client";

export const kratos = new FrontendApi(
  new Configuration({
    basePath: `${process.env.NEXT_PUBLIC_KRATOS_URL}`,
    baseOptions: {
      withCredentials: true,
    },
  }),
);
